import Icon from '../components/Icon.vue'

Icon.register({
  ankh: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M296 256c13.3 0 24 10.7 24 24v32c0 13.3-10.8 24-24 24h-96v152c0 13.3-10.8 24-24 24h-32c-13.3 0-24-10.8-24-24v-152h-96c-13.3 0-24-10.8-24-24v-32c0-13.3 10.8-24 24-24h44.6c-21.1-34-36.6-74.3-36.6-112 0-88.4 57.3-144 128-144s128 55.6 128 144c0 37.7-15.5 78-36.6 112h44.6zM160 80c-29.6 0-48 24.5-48 64 0 34.7 27.1 78.2 48 100.9 20.9-22.7 48-66.2 48-100.9 0-39.5-18.4-64-48-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ankh.js
// module id = 611
// module chunks = 0